export const defaultOutlets = {
  // 보수언론사
  조선일보: {
    id: "chosun",
    name: "조선일보",
    summary:
      "1920년 창간된 전국 종합 일간지. 보수 성향의 논조로 알려져 있으며, 조선미디어그룹의 핵심 매체로 디지털 전환(조선닷컴, 유튜브 등)에도 적극적이다.",
    profile: {
      설립: "1947년 3월 17일",
      창간: "1920년 3월 5일",
      경영진: {
        사장: "방준오",
        회장: "방상훈",
      },
      본사_위치: "서울특별시 중구(세종대로 일대).",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 영상 채널 운영",
      편집_방침_핵심: [
        "시장경제 및 한미동맹 중시",
        "정부규제 축소·민간 주도 성장 강조",
        "안보 이슈에서 강경·억지력 중시",
      ],
      보도_성향_요약: [
        "시장·안보 이슈 보도 비중 높음",
        "진보 진영·정부 정책 비판 기사 빈도 높음",
        "사설·칼럼에서 보수·반(反)포퓰리즘 논조 명확",
      ],
    },
    소유구조_지배구조: {
      요약: "조선일보사(조선미디어그룹). 가족경영 중심의 지배구조로 알려져 있음.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.chosun.com" },
      { label: "조선닷컴", href: "https://www.chosun.com" },
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@chosunmedia" },
      { platform: "facebook", url: "https://www.facebook.com/chosun" },
      { platform: "x", url: "https://twitter.com/Chosun" },
      { platform: "insta", url: "https://www.instagram.com/_chosunilbo_" },
    ],
  },
  중앙일보: {
    id: "joongang",
    name: "중앙일보",
    summary:
      "1965년 창간된 전국 종합 일간지. 조중동(조선·중앙·동아)으로 불리는 주요 보수 성향 신문 중 하나로, 비교적 중도·실용적 보수 이미지를 강조하는 경향이 있다.",
    profile: {
      설립: "1965년 3월 17일",
      창간: "1965년 9월 22일",
      경영진: {
        사장: "박장희",
        회장: "-",
      },
      본사_위치: "서울특별시 마포구 상암산로 48-6",
      발행_형태: "종합 일간지(조간), 디지털(중앙일보·JTBC 뉴스), 영상·오디오",
      편집_방침_핵심: [
        "시장경제 및 글로벌 경쟁력 중시",
        "정치·사회 문제에 대한 실용적 접근",
        "한미동맹·대외 협력 강조",
      ],
      보도_성향_요약: [
        "경제·정책·국제 이슈 보도 비중 높음",
        "실용·중도보수 관점의 정책 평가 기사 많음",
        "사설·칼럼에서 시장친화·현실주의 노선 비교적 일관",
      ],
    },
    소유구조_지배구조: {
      요약: "중앙그룹(홍석현 일가 중심). 미디어 계열사 다수를 보유.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.joongang.co.kr" },
      { label: "JTBC 뉴스", href: "https://news.jtbc.co.kr" },
    ],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCH3mJ-nHxjjny2FJbJaqiDA",
      },
      { platform: "facebook", url: "https://www.facebook.com/joongang" },
      { platform: "x", url: "https://x.com/joongangilbo" },
      { platform: "insta", url: "https://www.instagram.com/joongangilbo/" },
    ],
  },
  동아일보: {
    id: "donga",
    name: "동아일보",
    summary:
      "1920년 창간된 전국 종합 일간지. 조중동(조선·중앙·동아)으로 불리는 보수 성향의 주요 일간지 중 하나로, 전통적인 보수 논조와 함께 사회·문화 분야 보도에도 강점을 보인다.",
    profile: {
      설립: "1920년 4월 1일",
      창간: "1920년 4월 1일",
      경영진: {
        사장: "임채청",
        회장: "김재호",
      },
      본사_위치: "서울특별시 종로구 청계천로 1 (서린동, 동아미디어센터)",
      발행_형태:
        "종합 일간지(조간), 디지털(동아닷컴), 잡지·출판, 방송 계열 연계",
      편집_방침_핵심: [
        "시장경제 및 자유민주주의 가치 중시",
        "사회 안정과 안보 강화 강조",
        "한미동맹 중시 및 대북 강경 입장",
      ],
      보도_성향_요약: [
        "안보·외교·질서 이슈 보도 비중 높음",
        "정치 기사에서 보수 프레임·비판 보도 잦음",
        "사설·칼럼에서 전통적 보수 논조 유지",
      ],
    },
    소유구조_지배구조: {
      요약: "동아일보사(동아미디어그룹). 역사적으로 가족 경영 기반.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.donga.com" },
      { label: "동아닷컴", href: "https://www.donga.com" },
    ],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCnHyx6H7fhKfUoAAaVGYvxQ",
      },
      { platform: "facebook", url: "https://www.facebook.com/dongamedia" },
      { platform: "x", url: "https://x.com/dongamedia" },
      {
        platform: "insta",
        url: "https://www.instagram.com/dongailbo_official/?hl=ko",
      },
    ],
  },
  // 연합뉴스: {
  //   id: "yna",
  //   name: "연합뉴스",
  //   summary:
  //     "1980년 설립된 대한민국의 국가기간뉴스통신사. 정부 지원을 받는 공적 성격의 언론사로, 신속하고 포괄적인 뉴스 공급에 중점을 두며 정치적으로는 중도·공영적 성격을 가진 것으로 평가된다.",
  //   profile: {
  //     설립: "1980년 12월 19일",
  //     창간: "1980년 12월 19일",
  //     경영진: {
  //       사장: "황대일",
  //       회장: "-",
  //     },
  //     본사_위치: "서울특별시 종로구 율곡로2길 25 (수송동)",
  //     발행_형태:
  //       "통신사 기사 배급(신문·방송·온라인 매체 대상), 디지털(연합뉴스 홈페이지·앱), 다국어 뉴스 서비스",
  //     편집_방침_핵심: [
  //       "국내외 뉴스의 신속·정확한 보도",
  //       "정치적 중립성과 공적 책임 강조",
  //       "다언어·다매체 글로벌 뉴스 공급",
  //     ],
  //     보도_성향_요약: [
  //       "속보·사실 전달 중심(스트레이트) 보도 비중 높음",
  //       "공식 발표·기관 자료 인용 비중 큼",
  //       "논조는 중립 지향이나 이슈별 프레이밍 차이 존재",
  //     ],
  //   },
  //   소유구조_지배구조: {
  //     요약: "정부 지분 일부 보유 및 뉴스통신진흥회 산하. 공적 지원과 민간 광고 수익을 병행.",
  //   },
  //   참고_링크: [
  //     { label: "공식 홈페이지", href: "https://www.yna.co.kr" },
  //     { label: "영문 Yonhap News", href: "https://en.yna.co.kr" },
  //   ],
  //   sns_links: [
  //     { platform: "youtube", url: "https://www.youtube.com/yonhap" },
  //     { platform: "facebook", url: "https://www.facebook.com/yonhap" },
  //     { platform: "x", url: "https://x.com/yonhaptweet" },
  //     { platform: "insta", url: "https://www.instagram.com/yonhap_news" },
  //   ],
  // },
  국민일보: {
    id: "kmib",
    name: "국민일보",
    summary:
      "1988년 창간된 전국 종합 일간지. 기독교 기반의 미션(공익·윤리)을 강조해 온 매체로, 사회·문화 이슈에서 비교적 보수적 가치관을 반영하는 경우가 있다.",
    profile: {
      설립: "1997년 11월 11일",
      창간: "1988년 12월 10일",
      경영진: {
        사장: "김경호",
        회장: "조민제",
      },
      본사_위치: "서울특별시 영등포구 여의공원로 101",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 영상·오디오 콘텐츠",
      편집_방침_핵심: [
        "공익·윤리 중심 보도 지향",
        "종교·문화·가치 이슈에 대한 심층 보도",
        "균형·상식에 기반한 정책 평가",
      ],
      보도_성향_요약: [
        "사회·문화·종교/가치 이슈 보도 비중 높음",
        "윤리·가족·종교 관점의 해석 기사 존재",
        "사설·칼럼에서 비교적 보수적 가치 논조 유지",
      ],
    },
    소유구조_지배구조: {
      요약: "국민일보사. 역사적으로 종교계와의 연관성이 알려져 있으며, 경영·편집 독립을 표방.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.kmib.co.kr" },
      { label: "모바일", href: "https://m.kmib.co.kr" },
    ],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCSuuVcF9lix5dwFmAPkHE-g",
      },
      { platform: "facebook", url: "https://www.facebook.com/kukmindaily" },
      { platform: "x", url: "https://x.com/TheKukminDaily" },
      {
        platform: "insta",
        url: "https://www.instagram.com/kukminilbo_official/",
      },
    ],
  },
  세계일보: {
    id: "segye",
    name: "세계일보",
    summary:
      "1989년 창간된 전국 종합 일간지. 종교계(통일교) 기반으로 설립된 신문으로, 보수 성향·가치 이슈와 함께 탐사보도·국제 뉴스 비중이 비교적 큰 편으로 알려져 있다.",
    profile: {
      설립: "1989년 2월 1일",
      창간: "1989년 2월 1일",
      경영진: {
        사장: "-",
        회장: "-",
      },
      본사_위치: "서울특별시 용산구 서빙고로 17",
      발행_형태:
        "종합 일간지(조간), 디지털(웹/모바일), 오피니언·기획·국제 뉴스",
      편집_방침_핵심: [
        "‘애천·애인·애국’ 등 설립 이념을 바탕으로 한 가치·윤리 담론 강조",
        "탐사보도·기획 기사 등을 통한 권력 감시·사회 책임 의식 강조",
        "국내·국제 이슈를 아우르는 종합 보도 지향",
      ],
      보도_성향_요약: [
        "정치·사회·국제 이슈를 폭넓게 보도",
        "가치·윤리 담론 및 보수 관점 기사 비중 존재",
        "사설·칼럼에서 비교적 명확한 입장 표출",
      ],
    },
    소유구조_지배구조: {
      요약:
        "세계기독교통일신령협회유지재단 등 통일교 관련 재단이 주요 주주로 알려져 있으며, 종교계 기반 민간 미디어 그룹 구조를 형성.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.segye.com" }
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@segyetimes" },
      { platform: "facebook", url: "https://www.facebook.com/segyetimes" },
      { platform: "x", url: "https://x.com/segyecom" },
      { platform: "insta", url: "https://www.instagram.com/segyetimes/" },
    ],
  },
  서울신문: {
    id: "seoulshinmun",
    name: "서울신문",
    summary:
      "대한민국의 전국 종합 일간지로, 비교적 중도 성향으로 평가된다. 공공성·생활밀착형 이슈와 정책 해설성 보도에 강점을 보이며, 디지털 전환도 병행하고 있다.",
    profile: {
      설립: "1945년 11월 22일",
      창간: "1904년 7월 18일 대한매일신보",
      경영진: {
        사장: "김성수",
        회장: "김상열",
      },
      본사_위치: "서울특별시 중구 세종대로 124 (태평로1가)",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 영상·오디오",
      편집_방침_핵심: [
        "정책·행정·생활 이슈의 균형 보도",
        "공공성·사회적 책임 강조",
        "데이터·해설형 기사 강화",
      ],
      보도_성향_요약: [
        "정책·행정·생활 이슈 보도 비중 높음",
        "온건한 톤의 해설·정보성 기사 많음",
        "사설·칼럼은 중도 성향으로 절충적 논조",
      ],
    },
    소유구조_지배구조: {
      요약: "민간·공공 혼합 지분 구조로 알려져 있으며, 편집 독립 및 공공성의 균형을 지향.",
    },
    참고_링크: [{ label: "공식 홈페이지", href: "https://www.seoul.co.kr" }],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCliLFbDUdp5P1RQzyHYgtFQ",
      },
      { platform: "facebook", url: "https://www.facebook.com/TheSeoulShinmun" },
      { platform: "x", url: "https://x.com/SeoulShinmun" },
      { platform: "insta", url: "https://www.instagram.com/seoulshinmun" },
    ],
  },
  문화일보: {
    id: "munhwa",
    name: "문화일보",
    summary:
      "전국 종합 일간지로 정치·경제·사회 전반을 다루며, 사설·칼럼 등 오피니언과 문화·생활 섹션 비중이 큰 편이다. 전통적 보수 성향으로 분류되는 경우가 많다.",
    profile: {
      설립: "1990년 8월 29일",
      창간: "1991년 11월 1일",
      경영진: {
        사장: "김병직",
        회장: "이병규",
      },
      본사_위치: "서울특별시 중구 새문안로 22 (충정로1가 68)",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 오피니언·기획",
      편집_방침_핵심: [
        "시장경제·자유민주주의 가치 강조",
        "안보·법치·질서 중시",
        "문화·생활 섹션의 심층 기획",
      ],
      보도_성향_요약: [
        "안보·법치·이념 이슈 보도 비중 높음",
        "진보 진영 및 정부 정책 비판 기사 빈도 높음",
        "사설·칼럼에서 강한 보수 논조 유지",
      ],
    },
    소유구조_지배구조: {
      요약: "민간 소유 기반의 종합 일간지로 알려져 있으며, 편집 독립을 표방.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.munhwa.com" }
    ],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCIpKI35IPtaDuBy0mVmN3bg",
      },
      { platform: "facebook", url: "https://www.facebook.com/munhwailbo" },
      { platform: "x", url: "https://www.instagram.com/munhwailbo/" },
      { platform: "insta", url: "https://www.instagram.com/munhwailbo/" },
    ],
  },
  
  // 보수 방송사
  // YTN: {
  //   id: "ytn",
  //   name: "YTN",
  //   summary:
  //     "1993년 개국한 대한민국 최초의 24시간 뉴스 전문 채널. 속보 중심의 실시간 보도에 강점을 가지고 있으며, 비교적 중도 성향으로 평가되나 이슈별 편향 논란도 존재한다.",
  //   profile: {
  //     설립: "1993년 9월 14일",
  //     창간: "1995년 3월 1일 (TV 개국)",
  //     경영진: {
  //       사장: "현재 사장대행",
  //       회장: "-",
  //     },
  //     본사_위치: "서울특별시 마포구 상암산로 76 (상암동)",
  //     발행_형태: "24시간 뉴스 방송, 디지털 뉴스(웹·모바일), 유튜브·SNS",
  //     편집_방침_핵심: [
  //       "속보성·실시간 정보 전달",
  //       "시청자의 알 권리 충족",
  //       "정치·사회 현안의 균형 보도 지향",
  //     ],
  //     보도_성향_요약: [
  //       "속보·현안 전달 중심의 실시간 보도",
  //       "정치·사건 이슈에서 균형 지향(이슈별 논란 존재)",
  //       "사설·오피니언보다 스트레이트 비중 큼",
  //     ],
  //   },
  //   소유구조_지배구조: {
  //     요약: "뉴스통신진흥회 및 공적 지분 기반 구조. 민간 투자와 공적 관리 병행.",
  //   },
  //   참고_링크: [
  //     { label: "공식 홈페이지", href: "https://www.ytn.co.kr" },
  //     { label: "YTN 유튜브", href: "https://www.youtube.com/user/ytnnews" },
  //   ],
  //   sns_links: [
  //     { platform: "youtube", url: "https://www.youtube.com/@ytnnews24" },
  //     { platform: "facebook", url: "https://www.facebook.com/ytn.co.kr" },
  //     { platform: "x", url: "https://x.com/YTN24" },
  //     { platform: "insta", url: "https://www.instagram.com/ytnnews" },
  //   ],
  // },
  채널A: {
    id: "ichannela",
    name: "채널A",
    summary:
      "2011년 개국한 종합편성채널. 동아미디어그룹 계열로 보도·시사·예능·교양 등 종합 편성을 하고 있으며, 전반적으로 보수 성향으로 분류되는 경우가 많다.",
    profile: {
      설립: "-",
      창간: "2011년 12월 1일 (개국)",
      경영진: {
        사장: "-",
        회장: "-",
      },
      본사_위치: "서울특별시 종로구 청계천로 1 (동아미디어센터)",
      발행_형태:
        "종합편성채널 TV, 뉴스·시사·예능·교양, 디지털(웹/모바일·유튜브)",
      편집_방침_핵심: [
        "시사·뉴스 중심의 종합 편성",
        "시청자 친화적·오락성을 가미한 포맷",
        "현장 리포트와 스튜디오 토크 결합",
      ],
      보도_성향_요약: [
        "정치·사건 중심의 이슈 드리븐 편성",
        "토크·논쟁형 포맷 비중 높음",
        "전반적으로 보수 성향 프레임이 자주 나타남",
      ],
    },
    소유구조_지배구조: {
      요약:
        "동아미디어그룹(DAMG) 계열 종합편성채널로, 최대주주는 동아일보 등을 포함한 동아미디어그룹. 신문·방송 통합 뉴스룸 구조를 지향.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.ichannela.com" },
      { label: "채널A 뉴스", href: "https://www.ichannela.com/news" },
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@channelA-news" },
      { platform: "facebook", url: "https://www.facebook.com/channelanews" },
      { platform: "x", url: "https://x.com/ChannelA_joah" },
      { platform: "insta", url: "https://www.instagram.com/channela_insta" },
    ],
  },
  MBN: {
    id: "mbn",
    name: "MBN",
    summary:
      "2011년 종합편성채널로 전환한 매일경제 계열 방송사. 뉴스·시사·경제·예능·교양 등 종합 편성을 수행하며, 전반적으로 보수 성향으로 분류되는 경우가 많다.",
    profile: {
      설립: "-",
      창간: "2011년 12월 1일 (종편 전환, 케이블 뉴스 채널은 1995년 출범)",
      경영진: {
        사장: "-",
        회장: "-",
      },
      본사_위치: "서울특별시 중구 퇴계로 190 (필동2가, 매경미디어센터)",
      발행_형태:
        "종합편성채널 TV, 뉴스·시사·경제·예능·교양, 디지털(웹/모바일·유튜브)",
      편집_방침_핵심: [
        "경제·경영·투자 정보에 강점",
        "뉴스·시사와 예능을 결합한 포맷",
        "시청자 친화적 스튜디오 토크·패널 토론 중심",
      ],
      보도_성향_요약: [
        "사건·정치·경제를 토크형 포맷으로 구성",
        "이슈별 논쟁 프레임·자극적 구성 비중 존재",
        "전반적으로 보수 성향으로 분류되는 편",
      ],
    },
    소유구조_지배구조: {
      요약:
        "매일경제미디어그룹 계열 종합편성채널로, 최대주주는 매일경제신문사 등. 경제지·방송·디지털 플랫폼을 연계한 미디어 그룹 구조.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.mbn.co.kr" },
      { label: "MBN 뉴스", href: "https://www.mbn.co.kr/news" },
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@MBNNEWS" },
      { platform: "facebook", url: "https://www.facebook.com/mbnnewskorea" },
      { platform: "x", url: "https://x.com/mbnnews" },
      { platform: "insta", url: "https://www.instagram.com/mbnnews_official" },
    ],
  },
  // KBS: {
  //   id: "kbs",
  //   name: "KBS",
  //   summary:
  //     "대한민국의 대표적인 공영방송사로, TV·라디오·디지털 플랫폼을 통해 뉴스·시사·드라마·예능·교양 등 종합 편성을 수행한다. 공적 책무와 공정성·균형성을 강조하며, 전반적으로 중도·공영적 성격으로 평가된다.",
  //   profile: {
  //     설립: "1973년 3월 3일 (한국방송공사 전환)",
  //     창간: "1927년 라디오 방송 개시(경성방송국) 이후 공영방송으로 발전",
  //     경영진: {
  //       사장: "-",
  //       회장: "-",
  //     },
  //     본사_위치: "서울특별시 영등포구 여의공원로 13 (여의도동, KBS 본관)",
  //     발행_형태:
  //       "지상파 TV·라디오, 디지털(웹/모바일), KBS NEWS·KBS WORLD 등 다채널 서비스",
  //     편집_방침_핵심: [
  //       "공영방송으로서의 공공성·공정성·독립성 강조",
  //       "정치·경제·사회 전반에 걸친 균형 보도",
  //       "지역·문화·교육·복지 등 공공 서비스 프로그램 강화",
  //     ],
  //     보도_성향_요약: [
  //       "공영방송으로 균형·공식 보도 비중 높음",
  //       "정책·생활·지역 이슈를 폭넓게 다룸",
  //       "정권/이사회 구성에 따른 편향 논란이 주기적으로 제기",
  //     ],
  //   },
  //   소유구조_지배구조: {
  //     요약:
  //       "공영방송사로, 방송법에 따른 공적 지배구조를 갖추고 있으며 수신료·광고 수익 등을 기반으로 운영. 편집권 독립과 공공성을 법적으로 규정하고 있음.",
  //   },
  //   참고_링크: [
  //     { label: "KBS 공식 홈페이지", href: "https://www.kbs.co.kr" },
  //     { label: "KBS NEWS", href: "https://news.kbs.co.kr" },
  //   ],
  //   sns_links: [
  //     { platform: "youtube", url: "https://www.youtube.com/@KBSNews" },
  //     { platform: "facebook", url: "https://www.facebook.com/KBSnews" },
  //     { platform: "x", url: "https://x.com/KBSnews" },
  //     { platform: "insta", url: "https://www.instagram.com/kbsnews/" },
  //   ],
  // },
  JTBC: {
    id: "jtbc",
    name: "JTBC",
    summary:
      "2011년 개국한 종합편성채널로, 중앙그룹 계열 방송사이다. '뉴스룸' 등 시사·보도 프로그램을 통해 탐사·팩트체크·인터뷰 중심의 보도로 신뢰도를 쌓았으며, 전반적으로 개혁·진보 성향으로 평가되는 경우가 많다.",
    profile: {
      설립: "2011년 3월 21일",
      창간: "2011년 12월 1일 (종편 개국)",
      경영진: {
        사장: "-",
        회장: "-",
      },
      본사_위치: "서울특별시 마포구 상암산로 48-6 (상암동, JTBC 빌딩)",
      발행_형태:
        "종합편성채널 TV, 뉴스·시사·예능·교양·드라마, 디지털(웹/모바일·유튜브·OTT 연계)",
      편집_방침_핵심: [
        "탐사보도·팩트체크 중심의 뉴스 보도",
        "심층 인터뷰·토론 프로그램 강화",
        "시민·시청자 관점의 공공성·다양성 추구",
      ],
      보도_성향_요약: [
        "탐사·팩트체크·인터뷰 중심 보도",
        "권력 감시·개혁 의제 보도 비중 높음",
        "해설·코멘터리에서 비교적 진보 논조",
      ],
    },
    소유구조_지배구조: {
      요약:
        "중앙그룹 계열 방송사로, 중앙일보 등과 함께 통합 뉴스룸·미디어 그룹 구조를 이루고 있으며, 편집권 독립과 공공성 강화를 표방.",
    },
    참고_링크: [
      { label: "JTBC 공식 홈페이지", href: "https://jtbc.co.kr" },
      { label: "JTBC 뉴스", href: "https://news.jtbc.co.kr" },
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@jtbc_news" },
      { platform: "facebook", url: "https://www.facebook.com/JTBCnews" },
      { platform: "x", url: "https://x.com/JTBC_news" },
      { platform: "insta", url: "https://www.instagram.com/jtbcnews/" },
    ],
  },
  // SBS: {
  //   id: "sbs",
  //   name: "SBS",
  //   summary:
  //     "1990년 설립된 민영 지상파 방송사로, TV·라디오·디지털 플랫폼을 통해 뉴스·시사·드라마·예능·스포츠 등 종합 편성을 수행한다. 상업 방송이지만 공공성과 시사 보도의 비중이 크며, 전반적으로 중도 성향으로 평가되는 경우가 많다.",
  //   profile: {
  //     설립: "1990년 11월 14일",
  //     창간: "1991년 12월 1일 (지상파 TV 개국)",
  //     경영진: {
  //       사장: "-",
  //       회장: "-",
  //     },
  //     본사_위치: "서울특별시 양천구 목동서로 161 (SBS 방송센터)",
  //     발행_형태:
  //       "지상파 TV·라디오, 디지털(웹/모바일), 뉴스·시사·드라마·예능·스포츠 등 종합 편성",
  //     편집_방침_핵심: [
  //       "상업 민영 지상파로서의 경쟁력·대중성 추구",
  //       "뉴스·시사 부문의 탐사·기획·팩트체크 강화",
  //       "다양한 장르의 예능·드라마·스포츠 콘텐츠 편성",
  //     ],
  //     보도_성향_요약: [
  //       "스트레이트+기획을 혼합한 종합 뉴스",
  //       "사건·생활 이슈 비중도 큰 편",
  //       "전반적으로 중도 성향(이슈별 편차 존재)",
  //     ],
  //   },
  //   소유구조_지배구조: {
  //     요약:
  //       "태영건설을 모태로 한 SBS 미디어홀딩스 계열 민영 방송사. 지주회사·자회사 구조를 통해 방송·콘텐츠·플랫폼 사업을 전개하며, 상업 방송이면서도 공공성과 편집권 독립을 표방.",
  //   },
  //   참고_링크: [
  //     { label: "SBS 공식 홈페이지", href: "https://www.sbs.co.kr" },
  //     { label: "SBS 뉴스", href: "https://news.sbs.co.kr" },
  //   ],
  //   sns_links: [
  //     { platform: "youtube", url: "https://www.youtube.com/sbs8news" },
  //     { platform: "facebook", url: "https://www.facebook.com/SBS8news" },
  //     { platform: "x", url: "https://x.com/SBS8news" },
  //     { platform: "insta", url: "https://www.instagram.com/sbsnews/" },
  //   ],
  // },

  // 중도언론사
  내일신문: {
    id: "naeil",
    name: "내일신문",
    summary:
      "대한민국의 전국 종합 일간지. 생활·정책·교육·지역 이슈에 강점을 보이며, 비교적 중도 성향으로 평가된다. 공공성·생활 밀착형 해설 보도를 지향한다.",
    profile: {
      설립: "1993년 6월 21일",
      창간: "1993년 6월 21일",
      경영진: {
        사장: "장명국",
        회장: "-",
      },
      본사_위치: "서울특별시 중구 새문안로3길 3 (신문로1가)",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 기획·해설 콘텐츠",
      편집_방침_핵심: [
        "정책·생활 정보 중심의 균형 보도",
        "지역·교육·복지 등 공공 의제 비중 확대",
        "데이터·해설형 기사 강화",
      ],
      보도_성향_요약: [
        "정책·교육·지역/생활 이슈 보도 비중 높음",
        "해설·정보성 기사 중심의 균형 지향",
        "사설·칼럼은 비교적 온건한 중도 논조",
      ],
    },
    소유구조_지배구조: {
      요약: "민간 소유 기반의 종합 일간지로, 편집 독립과 공공성의 균형을 지향. 주식의 62%를 사원들이 보유하고 있음.",
    },
    참고_링크: [{ label: "공식 홈페이지", href: "https://www.naeil.com" }],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCTCvmGcztNwdJ15yoky75Vg",
      },
      { platform: "facebook", url: "https://www.facebook.com/naeilnews/" },
      { platform: "x", url: "https://x.com/naeilsinmun" },
      { platform: "insta", url: "https://www.instagram.com/naeilsinmun/" },
    ],
  },
  한국일보: {
    id: "hankookilbo",
    name: "한국일보",
    summary:
      "대한민국의 전국 종합 일간지로, 비교적 중도 성향으로 평가된다. 균형 잡힌 해설과 생활·정책·문화 이슈를 폭넓게 다루며 디지털 전환을 강화하고 있다.",
    profile: {
      설립: "1977년 12월 14일",
      창간: "1954년 6월 9일",
      경영진: {
        사장: "이성철",
        회장: "송명호",
      },
      본사_위치: "서울특별시 중구 세종대로 17 (남대문로5가 6-1)",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 영상·오디오",
      편집_방침_핵심: [
        "중도·균형 지향의 정책 해설",
        "생활·문화·기획 보도 강화",
        "데이터·비주얼 기반 심층 콘텐츠",
      ],
      보도_성향_요약: [
        "사회·생활·정책 해설 기사 비중 높음",
        "극단적 논조보다 균형·맥락 설명 지향",
        "사설·칼럼은 중도 성향으로 절제된 톤",
      ],
    },
    소유구조_지배구조: {
      요약: "민간 소유 기반의 종합 일간지로 알려져 있으며, 편집 독립과 공공성의 균형을 지향.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.hankookilbo.com" },
    ],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UC1aS5CRRDrN6CmR2VcpmetA",
      },
      { platform: "facebook", url: "https://www.facebook.com/hkilbo/" },
      { platform: "x", url: "https://x.com/hankookilbo" },
      { platform: "insta", url: "https://www.instagram.com/hankookilbo" },
    ],
  },
  뉴시스: {
    id: "newsis",
    name: "뉴시스",
    summary:
      "2000년대 초 출범한 민영 뉴스통신사. 신속·정확한 속보와 전국·국제 네트워크를 기반으로 멀티미디어 기사(텍스트·사진·영상)를 공급하며, 포털·언론사·기관 등에 배급한다.",
    profile: {
      설립: "2001년 9월 6일",
      창간: "2001년 9월 6일",
      경영진: {
        사장: "염영남",
        회장: "-",
      },
      본사_위치: "서울특별시 중국 퇴계로 173 (충무로3가, 남산스퀘어 12층)",
      발행_형태:
        "통신사 기사 배급(신문·방송·온라인 매체 대상), 디지털(홈페이지·앱), 사진·영상 뉴스",
      편집_방침_핵심: [
        "신속·정확한 속보와 사실 중심 보도",
        "정치적 중립성과 공공성 지향",
        "멀티미디어 뉴스 콘텐츠 강화",
      ],
      보도_성향_요약: [
        "속보·사진·영상 등 멀티미디어 기사 비중 높음",
        "기관·현장발 기사 다량 배급(통신사 성격)",
        "논조는 중립 지향이나 사건/정치 비중 높음",
      ],
    },
    소유구조_지배구조: {
      요약: "민영 뉴스통신사 구조로 알려져 있으며, 편집 독립과 공공성의 균형을 지향.",
    },
    참고_링크: [{ label: "공식 홈페이지", href: "https://www.newsis.com" }],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCAKGKvxlNWuWn1wGXZnr01Q",
      },
      { platform: "facebook", url: "https://www.facebook.com/newsis.news" },
      { platform: "x", url: "https://x.com/newsis" },
      { platform: "insta", url: "https://www.instagram.com/new_s_is/" },
    ],
  },


  // 진보언론사
  한겨레: {
    id: "hani",
    name: "한겨레",
    summary:
      "1988년 창간된 전국 종합 일간지. 국민주 모금으로 설립된 것으로 유명하며, 진보적인 논조를 대표하는 언론사로 꼽힌다. 시민사회와 노동 이슈에 대한 깊이 있는 보도를 지향한다.",
    profile: {
      설립: "1987년 12월 15일",
      창간: "1988년 5월 15일",
      경영진: {
        사장: "최우성",
        회장: "-",
      },
      본사_위치: "서울특별시 마포구 효창목길 6 (공덕동)",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 출판(한겨레출판)",
      보도_성향_요약: [
        "사회·노동·인권 이슈 보도 비중 높음",
        "정부·권력·재벌 비판 기사 빈도 높음",
        "사설·칼럼에서 진보적 논조 명확",
      ],
    },
    소유구조_지배구조: {
      요약: "국민주 방식의 한겨레신문사. 특정 대주주가 없는 소유분산 구조가 특징.",
    },
    참고_링크: [{ label: "공식 홈페이지", href: "https://www.hani.co.kr" }],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@HankyorehTV" },
      { platform: "facebook", url: "https://www.facebook.com/hankyorehtv" },
      { platform: "x", url: "https://twitter.com/hanitweet" },
      { platform: "insta", url: "https://www.instagram.com/hani.pic/" },
    ],
  },
  경향신문: {
    id: "khan",
    name: "경향신문",
    summary:
      "1940년대 창간된 전국 종합 일간지로, 진보적·개혁 성향의 논조로 분류되는 경우가 많다. 권력 감시·시민사회 이슈 보도에 강점을 보이는 것으로 알려져 있다.",
    profile: {
      설립: "1946년 10월 6일",
      창간: "1946년 10월 6일",
      경영진: {
        사장: "김석종",
        회장: "-",
      },
      본사_위치: "서울특별시 중구 정동길 3",
      발행_형태: "종합 일간지(조간), 디지털(웹/모바일), 영상·오디오 콘텐츠",
      편집_방침_핵심: [
        "권력 감시와 공공성 강화",
        "사회적 약자·노동·인권 이슈 중시",
        "남북 화해·평화 지향 및 외교 다자주의",
      ],
    },
    소유구조_지배구조: {
      요약: "임직원 지분을 바탕으로 한 독립 경영 모델로 알려져 있음(편집권 독립을 중시).",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.khan.co.kr" },
      { label: "경향 모바일", href: "https://m.khan.co.kr" },
    ],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCHXvjavEtkPFJCfGlm0wTXw",
      },
      {
        platform: "facebook",
        url: "https://www.facebook.com/kyunghyangshinmun/",
      },
      { platform: "x", url: "https://x.com/kyunghyang" },
      { platform: "insta", url: "https://www.instagram.com/kyunghyangshinmun" },
    ],
  },
  노컷뉴스: {
    id: "nocutnews",
    name: "노컷뉴스",
    summary:
      "CBS(기독교방송) 계열의 인터넷 뉴스 매체. 시사·정치 이슈에서 권력 감시와 공공성 강조에 무게를 두며, 진보적·개혁 성향으로 분류되는 경우가 많다.",
    profile: {
      설립: "2000년 5월 23일",
      창간: "2003년 11월 3일",
      경영진: {
        사장: "박상용",
        회장: "-",
      },
      본사_위치: "서울특별시 양천구 목동서로 159-1 7층",
      발행_형태: "디지털(웹/모바일) 중심, 라디오·영상 뉴미디어와 연계",
      편집_방침_핵심: [
        "권력 감시와 공공성 강화",
        "사회적 약자·노동·인권 의제 중시",
        "탐사·기획 보도의 비중 확대",
      ],
    },
    소유구조_지배구조: {
      요약: "CBS(기독교방송) 계열. 공익성과 편집 독립을 표방하는 구조.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.nocutnews.co.kr" },
    ],
    sns_links: [
      {
        platform: "youtube",
        url: "https://www.youtube.com/channel/UCa97kDUvLn9OSn9xTX0uM_g",
      },
      { platform: "facebook", url: "https://www.facebook.com/nocutnews/" },
      { platform: "x", url: "https://x.com/nocutnews" },
      { platform: "insta", url: "https://www.instagram.com/nocutnews/" },
    ],
  },
  프레시안: {
    id: "pressian",
    name: "프레시안",
    summary:
      "2000년대 초 출범한 독립 인터넷 뉴스 매체. 권력 감시와 공공성, 인권·환경·노동 등의 의제를 중시하며, 진보적·개혁 성향으로 분류되는 경우가 많다.",
    profile: {
      설립: "2001년 9월 24일",
      창간: "2001년 9월 24일",
      경영진: {
        사장: "박인규",
        회장: "-",
      },
      본사_위치: "서울특별시 마포구 양화로 10길 49 (서교동, 비케이빌딩 1층)",
      발행_형태: "디지털(웹/모바일) 중심, 데이터·기획·오피니언 비중",
      편집_방침_핵심: [
        "권력 감시와 공공성 강화",
        "인권·환경·노동 등 시민사회 의제 중시",
        "심층·탐사·해설 보도의 확대",
      ],
    },
    소유구조_지배구조: {
      요약: "독립 인터넷 언론사로, 편집권 독립과 공익성을 강조하는 구조로 알려져 있음.",
    },
    참고_링크: [{ label: "공식 홈페이지", href: "https://www.pressian.com" }],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@PRESSIAN_TV" },
      { platform: "facebook", url: "https://www.facebook.com/pressian.news" },
      { platform: "x", url: "https://x.com/PRESSIAN_news" },
      { platform: "insta", url: "https://www.instagram.com/pressian_/" },
    ],
  },
  오마이뉴스: {
    id: "ohmynews",
    name: "오마이뉴스",
    summary:
      "2000년 창간된 시민참여형 인터넷 뉴스 매체. \"모든 시민은 기자다\" 슬로건으로 시민기자 제도를 도입해 한국 온라인 저널리즘 확산을 주도했으며, 탐사·해설·오피니언 등 디지털 퍼스트 콘텐츠에 강점을 가진다.",
    profile: {
      설립: "2000년 2월 2일",
      창간: "2000년 2월 22일",
      경영진: {
        사장: "오연호",
        회장: "-",
      },
      본사_위치: "서울특별시 마포구 월드컵로14길 42-5 (서교동)",
      발행_형태: "디지털 중심(웹/모바일), 시민기자 기사·오피니언·탐사/기획",
      편집_방침_핵심: [
        "시민 참여와 권력 감시",
        "사회적 약자·지역·현장 중심 보도",
        "데이터·해설형 콘텐츠 및 스토리텔링 강화",
      ],
    },
    소유구조_지배구조: {
      요약: "인터넷 언론사 기반의 독립 경영 구조로 알려져 있으며, 시민기자 네트워크와 편집권 독립을 강조.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.ohmynews.com" },
      { label: "오마이TV", href: "https://omn.kr/tv" },
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@ohmynewstv" },
      { platform: "facebook", url: "https://www.facebook.com/OhmyNewsKorea" },
      { platform: "x", url: "https://x.com/OhmyNews_Korea" },
      { platform: "insta", url: "https://www.instagram.com/ohmynewskorea/" },
    ],
  },
  시사인: {
    id: "sisain",
    name: "시사인",
    summary:
      "탐사·해설 중심의 주간 시사매거진. 2007년 창간 이후 권력 감시와 심층 르포, 데이터·팩트체크 기획에 강점을 보여 왔으며, 디지털 플랫폼을 통해 해설형·롱폼 콘텐츠를 확장하고 있다.",
    profile: {
      설립: "2007년 8월 17일",
      창간: "2007년 8월 17일",
      경영진: {
        사장: "이숙이",
        회장: "-",
      },
      본사_위치: "서울특별시 중구 중림로 27, 3층 (중림동, 가톨릭출판사빌딩)",
      발행_형태: "주간지(매거진) + 디지털(웹/모바일), 탐사·해설·오피니언",
      편집_방침_핵심: [
        "권력 감시와 공공성 강화",
        "탐사보도·현장 르포·데이터 해설",
        "시민 권리·인권·사회개혁 의제 중시",
      ],
    },
    소유구조_지배구조: {
      요약: "독립 매체 지향. 편집권 독립과 공익성 중심의 운영 철학.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.sisain.co.kr" }
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/c/sisaineditor" },
      { platform: "facebook", url: "https://www.facebook.com/sisain" },
      { platform: "x", url: "https://x.com/sisain_editor" },
      { platform: "insta", url: "https://www.instagram.com/sisain_editor" },
    ],
  },
  미디어오늘: {
    id: "mediatoday",
    name: "미디어오늘",
    summary:
      "언론·미디어 산업을 집중적으로 다루는 전문 매체. 권력과 자본으로부터의 편집 독립, 언론 감시와 공공성을 핵심 가치로 삼으며, 미디어 정책·산업 구조·노동 이슈 등을 심층적으로 분석한다.",
    profile: {
      설립: "1995년 11월 6일",
      창간: "1995년 11월 6일",
      경영진: {
        사장: "이희정",
        회장: "-",
      },
      본사_위치: "서울특별시 영등포구 당산로47길 19, 3층 (당산동6가, 고암빌딩)",
      발행_형태: "디지털 중심(웹/모바일), 주간/기획·해설·오피니언",
      편집_방침_핵심: [
        "언론 감시와 편집권 독립",
        "미디어 정책·산업 구조에 대한 비판적 해설",
        "노동·인권·플랫폼 공정성 등 공공성 강화",
      ],
    },
    소유구조_지배구조: {
      요약: "독립 매체 지향. 공익성·편집권 독립을 강조하는 운영 철학.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.mediatoday.co.kr" }
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@%EB%AF%B8%EB%94%94%EC%96%B4%EC%98%A4%EB%8A%98-v7l" },
      { platform: "facebook", url: "https://www.facebook.com/mediatodaynews" },
      { platform: "x", url: "https://x.com/mediatodaynews" },
      { platform: "insta", url: "https://www.instagram.com/mediaonulnews/" },
    ],
  },

  // 진보 방송사
  MBC: {
    id: "imbc",
    name: "MBC",
    summary:
      "1961년 개국한 지상파 방송사로, 보도·시사·예능·드라마 등 종합 편성을 수행하는 공영방송이다. 권력 감시와 공공성, 다양성·인권 가치를 강조하며, 비교적 진보 성향으로 평가되는 경우가 많다.",
    profile: {
      설립: "1961년 2월 21일",
      창간: "1961년 12월 2일 (TV 방송 개시)",
      경영진: {
        사장: "-",
        회장: "-",
      },
      본사_위치: "서울특별시 마포구 성암로 267 (상암동 MBC 사옥)",
      발행_형태:
        "지상파 TV·라디오, 뉴스·시사·예능·드라마, 디지털(웹/모바일) 및 유튜브·OTT 연계",
      편집_방침_핵심: [
        "공영방송으로서의 공공성·독립성 강조",
        "권력 감시와 사회적 약자·소수자 관점의 보도",
        "다양성·인권·민주주의 가치 중시",
      ],
      보도_성향_요약: [
        "탐사·권력 감시 보도 비중 높음",
        "사회·인권·노동 의제에 적극적",
        "논조는 중도 진보 성향으로 평가",
      ],
    },
    소유구조_지배구조: {
      요약:
        "방송문화진흥회(방문진)를 중심으로 한 공영방송 구조. 공적 책무와 편집권 독립을 강조하는 지배구조를 갖고 있음.",
    },
    참고_링크: [
      { label: "공식 홈페이지", href: "https://www.imbc.com" },
      { label: "MBC 뉴스", href: "https://imnews.imbc.com" },
    ],
    sns_links: [
      { platform: "youtube", url: "https://www.youtube.com/@MBCNEWS" },
      { platform: "facebook", url: "https://www.facebook.com/MBCnews" },
      { platform: "x", url: "https://x.com/withMBC" },
      { platform: "insta", url: "https://www.instagram.com/mbcnews_official" },
    ],
  },

};
